<section class="container">
  <div class="flex flex-row justify-between items-start mb-1">
    <rfc-heading-widget [headingName]="defineTitleAndDescriptionWidgetObj('change_password')"></rfc-heading-widget>
    <mat-icon class="pointer" (click)="close()">close</mat-icon>
  </div>

  <form [formGroup]="changePasswordForm" class="mt-2">
    <div class="flex xs:flex-row justify-between gap-[2em] mt-1 mb-1">
      <mat-form-field class="full-width">
        <input matInput placeholder="{{ translate('oldPassword') }}" formControlName="oldPassword"
          [type]="hideOld ? 'password' : 'text'" />
        <mat-error *ngIf="control(this.changePasswordForm, 'oldPassword').hasError">
          {{ getErrorMessage("oldPassword") }}
        </mat-error>
        <mat-icon matSuffix (click)="hideOld = !hideOld" class="pointer">{{
          hideOld ? "visibility_off" : "visibility"
          }}</mat-icon>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput placeholder="{{ translate('newPassword') }}" formControlName="newPassword"
          [type]="hideNew ? 'password' : 'text'" />
        <mat-error *ngIf="control(this.changePasswordForm, 'newPassword').hasError">
          {{ getErrorMessage("newPassword") }}
        </mat-error>
        <mat-icon matSuffix (click)="hideNew = !hideNew" class="pointer">{{
          hideNew ? "visibility_off" : "visibility"
          }}</mat-icon>
      </mat-form-field>
    </div>

    <div class="flex flex-col xs:flex-row justify-center items-center gap-[2em] mt-2 mb-1">
      <button mat-flat-button (click)="submit()" [disabled]="
          !control(this.changePasswordForm, 'newPassword').valid ||
          control(this.changePasswordForm, 'newPassword').value.length === 0
        " class="ald-mat-button primary">
        {{ "confirm_send" | i18n | uppercase }}
      </button>
    </div>
  </form>
</section>